<template>
  <div class="countdown-product" v-if="isCountdownVisible">
    <div v-if="initialData.placement_type === 'product_page_small'" class="countdown-product--simple countdown-product--yellow">
      <span class="countdown-product__percent">%</span>
      <span class="countdown-product__title">
        {{ initialData.title }}
        {{ $t('product-page__countdown-duration') }}
        <span v-if="currentTime && currentTime.days > 0">
          {{ currentTime.days }}
          {{
            [$t('timer.day1'), $t('timer.day2'), $t('timer.day3')] | Pluralize(currentTime.days)
          }}
        </span>
        <span class="countdown-hours" v-else-if="currentTime">
          {{currentTime.hours}}:{{currentTime.minutes}}:{{currentTime.seconds}}
        </span>
        {{ $t('product-page__countdown-end-of-product') }}
      </span>
    </div>
    <component
      v-else
      :is="initialData.link ? 'a' : 'div'"
      class="product-countdown align-center-mob background-mob-cover background-cover"
      :class="computedClasses"
      :style="{'background-color': initialData.background_color}"
      :href="initialData.link || undefined"
    >
      <div class="product-countdown__image-block countdown-image">
        <div class="countdown-image__background">
          <img v-if="computedBackground"
               class="countdown-image__background-img"
               :src="computedBackground"
               alt="product countdown background">
        </div>
        <img v-if="computedImg" class="countdown-image__image" :src="computedImg" alt="product countdown image">
      </div>
      <div
        v-if="this.initialData.show_timer"
        class="product-countdown__timer-wrap">
        <Timer
          v-if="initialData.end_date"
          class="product-countdown__timer"
          is-product-page
          :title="$t('count_expiration')"
          :deadline="initialData.end_date"
          :type="computedTimerTheme"
        />
      </div>
    </component>
  </div>
</template>

<script>
import Timer from '@/components/promo-pages/Timer.vue'
import { mapState } from 'vuex'
import Pluralize from '@/filters/Pluralize'

export default {
  name: 'CountdownProduct',
  components: { Timer },
  data () {
    return {
      windowWidth: window.innerWidth,
      currentTime: null
    }
  },
  filters: {
    Pluralize
  },
  props: {
    initialData: {
      type: Object,
      default: () => ({}),
      required: true
    }
  },
  methods: {
    countdown () {
      let t = new Date(+this.initialData.end_date * 1000) - Date.parse(new Date())
      let seconds = Math.floor((t / 1000) % 60)
      let minutes = Math.floor((t / 1000 / 60) % 60)
      let hours = Math.floor((t / (1000 * 60 * 60)) % 24)
      let days = Math.floor(t / (1000 * 60 * 60 * 24))

      if (t > 0) {
        this.currentTime = {
          total: t,
          days: days,
          hours: hours < 10 ? '0' + hours : hours,
          minutes: minutes < 10 ? '0' + minutes : minutes,
          seconds: seconds < 10 ? '0' + seconds : seconds
        }

        setTimeout(this.countdown, 1000)
      } else {
        this.currentTime = null
      }
    }
  },
  mounted () {
    this.countdown()
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
  },
  computed: {
    ...mapState({
      isSale: state => state.productInfo.productInfo.isSale,
      isArchive: state => state.productInfo.productInfo.isArchive,
      productId: state => state.productInfo.productInfo.productId
    }),
    computedImg () {
      if ((this.windowWidth >= 769 && this.windowWidth <= 1350) || this.windowWidth <= 670) {
        return this.initialData.image_mobile
      }
      return this.initialData.image_1400 || this.initialData.image_1100 || this.initialData.image_768
    },
    computedBackground () {
      if ((this.windowWidth >= 769 && this.windowWidth <= 1350) || this.windowWidth <= 670) {
        return this.initialData.background_image_mobile
      }
      return this.initialData.background_image_1400 || this.initialData.background_image_1100 || this.initialData.background_image_768
    },
    computedClasses () {
      let classes = 'filled-timer '
      if (this.initialData.theme === 'white') {
        classes = classes + 'product-countdown--light '
      }
      if (!this.initialData.show_timer) {
        classes = classes + 'product-countdown--without-timer '
      }
      return classes
    },
    computedTimerTheme () {
      if (this.initialData.theme === 'white') {
        return 'light'
      }
      return 'dark'
    },
    isCountdownVisible () {
      if (this.initialData.start_date && this.initialData.end_date && new Date().getTime() <= this.initialData.end_date * 1000 && new Date().getTime() >= this.initialData.start_date * 1000) {
        if (this.isArchive) {
          return false
        }
        if (this.initialData.products_ids_excluded.length && this.initialData.products_ids_excluded.includes(this.productId)) {
          return false
        }
        if (this.initialData.products_ids_included.length && this.initialData.products_ids_included.includes(this.productId)) {
          return true
        }
        if (this.initialData.for_all_sale_products && this.isSale) {
          return true
        }
        if (this.initialData.for_all_not_sale_products && !this.isSale) {
          return true
        }
      }
      return false
    }
  }
}
</script>

<style scoped lang="sass">
.countdown-product
  &__percent
    width: 32px
    height: 32px
    border-radius: 50%
    display: flex
    flex-shrink: 0
    align-items: center
    justify-content: center
    font-size: 16px
    color: #333
    font-weight: 500
    margin-right: 15px
    background-color: #fff
    border: 1px solid transparent
  &__title
    font-size: 14px
    line-height: 1.2
    span
      font-weight: 500
      +mmax($small)
        &:after
          content: ''
          display: block
  &--simple
    padding: 6px 15px
    border: 1px solid transparent
    border-radius: 3px
    //margin-bottom: 30px
    display: flex
    align-items: center
    margin: 0 -15px 30px
    +mmax($tablet)
      border-right: none
      border-left: none
      border-radius: 0
      padding: 10px 15px
    +mmin($tablet)
      //margin-bottom: 20px
      margin: 0 0 20px
  &--yellow
    border-color: #FFC700
    background-color: #FFFAE9
    .countdown-product__percent
      border-color: #FFC700

.product-countdown__timer-wrap
  display: flex
  flex-flow: column
  align-items: center

  +mmin($small)
    margin: 0 0 0 auto

  +mmin($tablet)
    margin: 0 auto
    flex-flow: column

  +mmin($large)
    margin: 0 0 0 auto

  +mmin(1400)
    flex-flow: row nowrap

.product-countdown__text
  font-size: 14px
  font-weight: 400
  color: $white-text-color
  opacity: .7

.product-countdown__text
  margin: 0 auto
  order: 2

  +mmin(1400)
    order: initial
    margin-right: 10px

.product-countdown__timer
  margin: 10px auto

  +mmin($small)
    margin: 0 auto 10px

  +mmin($tablet)
    margin: 10px auto

  +mmin($large)
    margin: 0 auto 10px

  +mmin(1400)
    margin: 0 0 0 auto

.product-countdown--light
  .countdown-percents__text, .product-countdown__text
    color: $text-color

// image type
=image-type-adaptive()
  @media only screen and (min-width: #{$tablet}px) and (max-width: 1350px), (max-width: 670px)
    @content

=image-type-adaptive--hhours()
  @media only screen and (min-width: #{$tablet}px) and (max-width: #{$tablet--hor}px), (max-width: #{$extsmall--hor}px)
    @content

.product-countdown
  display: flex
  flex-flow: row nowrap
  align-items: center
  padding: 0 15px
  overflow: hidden
  position: relative
  background-color: #202020
  border-radius: 7px
  width: 100%
  margin-bottom: 40px

  &.py-15
    padding-bottom: 15px
    padding-top: 15px
    +image-type-adaptive
      padding-bottom: 30px
      padding-top: 30px

  &.px-30
    padding-left: 30px
    padding-right: 30px
    +image-type-adaptive
      padding-left: 15px
      padding-right: 15px

  &--light
    background-color: #f8f8f8

  .product-countdown__timer-wrap
    z-index: 2

  .countdown-image__background
    display: block
    position: absolute
    left: 0
    top: 0
    right: 0
    bottom: 0
    z-index: -1
    height: 100%
    width: 100%

  .countdown-image__background-img
    display: block
    width: 100%
    height: 100%
    object-fit: contain
    pointer-events: none

  +image-type-adaptive
    align-items: flex-start
    flex-flow: column
    padding: 10px 15px 20px

  .product-countdown__image-block,
  .product-countdown__timer-wrap
    z-index: 2

  .product-countdown__timer
    align-items: center
    margin: 0 0 0 auto

    +image-type-adaptive
      margin: 10px 0 0

  .product-countdown__timer-wrap
    margin: 0 0 0 auto

    +image-type-adaptive
      margin: 0

  .countdown-image__image
    display: block

  &.align-center-mob
    +image-type-adaptive
      align-items: center

  &.align-left-mob
    +image-type-adaptive
      align-items: flex-start

  &.background-cover
    .countdown-image__background-img
      object-fit: cover

  &.background-contain
    .countdown-image__background-img
      object-fit: contain

  &.background-position-left
    .countdown-image__background-img
      object-position: left

  &.background-position-right
    .countdown-image__background-img
      object-position: right

  &.background-position-center
    .countdown-image__background-img
      object-position: center

  &.background-mob-cover
    .countdown-image__background-img
      +image-type-adaptive
        object-fit: cover

  &.background-mob-contain
    .countdown-image__background-img
      +image-type-adaptive
        object-fit: contain

  &.background-mob-position-left
    .countdown-image__background-img
      +image-type-adaptive
        object-position: left

  &.background-mob-position-right
    .countdown-image__background-img
      +image-type-adaptive
        object-position: right

  &.background-mob-position-center
    .countdown-image__background-img
      +image-type-adaptive
        object-position: center

  &.without-padding
    padding: 0

  &.align-left-img
    .countdown-image
      width: 100%
      +image-type-adaptive
        width: auto

    .countdown-image__image
      margin: 0 auto 0 -15px
      +image-type-adaptive
        margin: 0

  &.align-right-img
    .countdown-image
      width: 100%
      +image-type-adaptive
        width: auto

    .countdown-image__image
      margin: 0 -15px 0 auto
      +image-type-adaptive
        margin: 0

  &.align-left-mob-img
    +image-type-adaptive
      .countdown-image
        width: 100%

      .countdown-image__image
        margin: 0 auto 0 -15px

  &.align-right-mob-img
    +image-type-adaptive
      .countdown-image
        width: 100%

      .countdown-image__image
        margin: 0 -15px 0 auto

  &.filled-timer
    ::v-deep
      .timer__title
        font-weight: 500

      .timer__container
        background: rgba(255, 255, 255, 1)

  &.reverse
    flex-flow: row-reverse
    +image-type-adaptive
      flex-flow: column

    .countdown-image
      margin: 0 0 0 auto
      +image-type-adaptive
        margin: 0

    .product-countdown__timer-wrap
      margin: 0
.countdown-hours
  min-width: 60px
  text-align: center
  display: inline-block
</style>
